export default {
    createSessions: '/session/createSessions',
    getSessionsEndPoint: '/session/getSessions'
    // getExams: '/newExam/getExams',
    // getExam: '/newExam/getExam',
    // deleteExam: '/newExam/deleteExam'
}
